/**
 * 用户管理API服务
 */
import { request } from '@/api/client'
import { API_ENDPOINTS as apiEndpoints } from '@/api/endpoints'

export interface User {
  id: number
  username: string
  email: string
  display_name?: string
  is_active: boolean
  created_at: string
  updated_at?: string
  [key: string]: any
}

export interface UserListParams {
  page?: number
  page_size?: number
  search?: string
  status?: string
  is_active?: boolean
  sort_by?: string
  order?: 'asc' | 'desc'
}

export const usersApi = {
  /**
   * 获取用户列表
   */
  getList(params?: UserListParams) {
    return request.get(apiEndpoints.USERS.LIST, { params })
  },

  /**
   * 获取用户详情
   */
  getDetail(id: number) {
    return request.get(apiEndpoints.USERS.DETAIL(id))
  },

  /**
   * 创建用户
   */
  create(data: Partial<User>) {
    return request.post(apiEndpoints.USERS.CREATE, data)
  },

  /**
   * 更新用户
   */
  update(id: number, data: Partial<User>) {
    return request.put(apiEndpoints.USERS.UPDATE(id), data)
  },

  /**
   * 删除用户
   */
  delete(id: number) {
    return request.delete(apiEndpoints.USERS.DELETE(id))
  },

  /**
   * 批量删除用户
   */
  batchDelete(ids: number[]) {
    return request.post(`${apiEndpoints.USERS.LIST}/batch-delete`, { ids })
  },

  /**
   * 更新用户状态
   */
  updateStatus(userId: number, isActive: boolean) {
    return request.put(`${apiEndpoints.USERS.DETAIL(userId)}/status`, {
      status: isActive ? 'active' : 'inactive'
    })
  },

  /**
   * 批量更新用户状态
   */
  batchUpdateStatus(userIds: number[], isActive: boolean) {
    return request.put(`${apiEndpoints.USERS.LIST}/batch/status`, {
      user_ids: userIds,
      status: isActive ? 'active' : 'inactive'
    })
  },

  /**
   * 匿名化删除用户（GDPR合规）
   * 删除个人身份信息，保留学习数据
   */
  anonymize(userId: number) {
    return request.post(`${apiEndpoints.USERS.DETAIL(userId)}/anonymize`)
  },

  /**
   * 重置用户密码
   */
  resetPassword(userId: number, newPassword: string) {
    return request.post(`${apiEndpoints.USERS.DETAIL(userId)}/reset-password`, {
      new_password: newPassword
    })
  }
}